import { styled } from '@mui/material/styles';
import {
    Box,
    Paper,
    Typography,
    Switch,
    TableContainer,
    TableCell,
    TableRow,
    Card
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
// 공통 스타일 import 및 re-export
import {
    FilterSection,
    DateFilterContainer,
    SectionTitle,
    ButtonContainer,
    TableControlBar,
    ScrollableTableContainer,
    StyledTableCell,
    StyledTableRow
} from '../../../components/styled/CommonStyles';

// 공통 스타일 re-export
export {
    FilterSection,
    DateFilterContainer,
    SectionTitle,
    ButtonContainer,
    TableControlBar,
    ScrollableTableContainer,
    StyledTableCell,
    StyledTableRow
};

export const StyledContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: theme.palette.background.default,
  minHeight: '100vh'
}));

export const FilterPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginBottom: theme.spacing(3),
  backgroundColor: theme.palette.background.paper
}));

export const TablePaper = styled(Paper)(({ theme }) => ({
  width: '100%',
  overflow: 'hidden',
  backgroundColor: theme.palette.background.paper
}));

export const StatusChip = styled('span')(({ theme, status }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'issued':
        return theme.palette.primary.main;
      case 'paid':
        return theme.palette.success.main;
      case 'partial_paid':
        return theme.palette.warning.main;
      case 'canceled':
        return theme.palette.error.main;
      default:
        return theme.palette.grey[500];
    }
  };

  return {
    display: 'inline-block',
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.spacing(1),
    backgroundColor: getStatusColor(status),
    color: theme.palette.common.white,
    fontSize: '0.75rem',
    fontWeight: 500,
    textAlign: 'center',
    minWidth: 60
  };
});

export const MobileCard = styled(Paper)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  '&:hover': {
    backgroundColor: theme.palette.action.hover
  }
}));

export const ControlBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
  padding: theme.spacing(1, 0)
}));

export const ColumnPanel = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.background.paper
}));

export const StyledDatePicker = styled(DatePicker)(({ theme }) => ({
    width: '160px',
    '& .MuiOutlinedInput-root': {
        height: '40px'
    }
}));

export const CustomSwitch = styled(Switch)(({ theme }) => ({
    width: 68,
    height: 34,
    padding: 7,
    '& .MuiSwitch-switchBase': {
        margin: 1,
        padding: 0,
        '&.Mui-checked': {
            transform: 'translateX(32px)',
            color: theme.palette.primary.main,
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: theme.palette.primary.light,
            },
        },
    },
    '& .MuiSwitch-thumb': {
        width: 30,
        height: 30,
        boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
        backgroundColor: '#fff',
        border: '1px solid rgba(0,0,0,0.2)',
    },
    '& .MuiSwitch-track': {
        opacity: 1,
        borderRadius: 20 / 2,
        backgroundColor: theme.palette.grey[400],
    },
}));

export const SwitchLabel = styled(Box)(({ theme }) => ({
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
}));

export const SwitchTextOn = styled(Typography)(({ theme, checked }) => ({
    position: 'absolute',
    left: '14px',
    fontSize: '0.75rem',
    fontWeight: 'bold',
    color: '#fff',
    visibility: checked ? 'visible' : 'hidden',
}));

export const SwitchTextOff = styled(Typography)(({ theme, checked }) => ({
    position: 'absolute',
    right: '10px',
    fontSize: '0.75rem',
    fontWeight: 'bold',
    color: '#fff',
    visibility: checked ? 'hidden' : 'visible',
}));

export const ColumnSelectionPanel = styled(Paper)(({ theme }) => ({
    position: 'absolute',
    top: 'calc(100% + 10px)',
    right: 0,
    width: '500px',
    maxWidth: '90vw',
    zIndex: 100,
    padding: theme.spacing(2),
    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
    borderRadius: theme.shape.borderRadius,
    opacity: 0,
    transform: 'translateY(-20px)',
    transition: 'opacity 0.3s ease, transform 0.3s ease',
    '&.open': {
        opacity: 1,
        transform: 'translateY(0)',
    }
}));

export const ColumnSelectionGrid = styled(Box)(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: theme.spacing(1.5),
    maxHeight: '300px',
    overflowY: 'auto',
    paddingRight: theme.spacing(1),
    '&::-webkit-scrollbar': {
        width: '6px',
    },
    '&::-webkit-scrollbar-track': {
        background: theme.palette.mode === 'dark' 
            ? theme.palette.grey[800] 
            : theme.palette.grey[100],
    },
    '&::-webkit-scrollbar-thumb': {
        background: theme.palette.mode === 'dark' 
            ? theme.palette.grey[600] 
            : theme.palette.grey[400],
        borderRadius: '3px',
    },
    [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: 'repeat(2, 1fr)',
    },
}));

export const ColumnSelectionItem = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(0.5),
    '&:hover': {
        backgroundColor: theme.palette.action.hover,
        borderRadius: theme.shape.borderRadius,
    },
    '& .MuiCheckbox-root': {
        padding: '4px',
    },
    '& .MuiTypography-root': {
        fontSize: '0.875rem',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
})); 